import {
  afterRenderEffect,
  booleanAttribute,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';

@Directive({ selector: '[compAutofocus]' })
export class AutofocusDirective {
  private readonly element = inject<ElementRef<HTMLInputElement | HTMLTextAreaElement>>(ElementRef);
  readonly compAutofocus = input(false, { transform: booleanAttribute });
  readonly compAutofocusTrigger = input<unknown>();

  constructor() {
    afterRenderEffect(() => {
      this.compAutofocusTrigger();

      if (!this.compAutofocus()) {
        return;
      }

      const nativeElement = this.element.nativeElement;
      nativeElement.focus();
    });
  }
}
